export enum SubscriptionsTab {
    overview = 'Overview',
    plans = 'Plans',
    paymentMethod = 'PaymentMethod',
    billingInfo = 'BillingInfo',
    billingHistory = 'BillingHistory'
}
